var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userRole)?_c('f-dashboard-user-sulteng',{attrs:{"userDetail":_vm.userDetail}}):(_vm.userAdmin)?_c('f-dashboard-admin-sulteng',{attrs:{"userDetail":_vm.userDetail}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }